module.exports = __webpack_public_path__ + "img/20191108155151324.a4ffc7ad.jpg";